import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { ReactSVG } from 'react-svg'
import { useMediaQuery } from 'usehooks-ts'

import { formatPriceAmount } from '@entities/Product/helpers'

import ControlCart from '@features/cart/ui/control'
import { FavoriteButton } from '@features/favorite'
import { InStock } from '@features/in-stock'



import { PriceOffer, Product } from '@shared/generated'
import { useIsAdult } from '@shared/hooks'
import { cn } from '@shared/lib/cn'
import BadgeGroup from '@shared/ui/badge/group'
import Badge from '@shared/ui/badge/item'
import RatingPreview from '@shared/ui/rating/preview/preview'
import { formatPrice } from '@shared/uttils'

import styles from './styles.module.scss'

export interface ProductPreviewCardProps {
  data: Product;
  className?: string;
}

export default function ProductPreviewCard ({
  data,
  className,
}: ProductPreviewCardProps) {
  const isTablet = useMediaQuery('(max-width: 767px)')
  const { isAdult } = useIsAdult()
  const { t: tf } = useTranslation('favorites')

  return (
    <div
      className={cn(styles.root, className, {
        [styles.blur]: !isAdult && data.is_alcohol,
      })}
    >
      <Link to={`/product/${data.slug}`} className={styles.root__top}>
        {!!data.preview?.url && (
          <img
            className={styles.root__img}
            src={data.preview?.url || ''}
            alt=""
            loading="lazy"
            fetchPriority="low"
          />
        )}

        {!data.preview?.url && (
          <ReactSVG
            className={styles.root__plug}
            src="/icons/flower.svg"
            wrapper="span"
          />
        )}

        <RatingPreview
          className={styles.root__rating}
          value={data.review_count || 0}
        />

        <FavoriteButton
          className={styles.root__favorite}
          id={data.id}
          isFavorite={!!data.isFavorite}
        />

        <BadgeGroup className={styles.root__badges}>
          {data.marketingLabels &&
            data.marketingLabels.map((item) => {
              return (
                <Badge 
                  key={item?.id}
                  backgroundColor={item?.optionBackgroundColor as string}
                  color={item?.optionColor as string}
                  image={item?.image?.url as string}
                />
              )
            })}

          {!isAdult && data.is_alcohol && (
            <Badge
              title={`${data.min_age ?? '21'}+`}
              backgroundColor={'#434242'}
            />
          )}
        </BadgeGroup>
      </Link>
      <div className={styles.root__bottom}>
        <Link
          className={styles['root__bottom-link']}
          to={`/product/${data.slug}`}
        >
          <div className={styles.root__info}>
            {data.priceOffer && (
              <div
                className={cn(styles.root__price, {
                  [styles._accent]: !!data.priceOffer.oldPrice,
                })}
              >
                {formatPrice(data.priceOffer?.price ?? 0)}{' '}
                <span>/ {formatPriceAmount({ priceOffer: data.priceOffer as PriceOffer, t: tf })}</span>{' '}
              </div>
            )}
            {/* <div className={styles.root__volume}>1 л</div> */}

            {!!data.priceOffer?.oldPrice && (
              <div className={styles['root__old-price']}>
                {formatPrice(data.priceOffer.oldPrice)}
              </div>
            )}
          </div>

          <h3 className={styles.root__name}>
            <span className={styles['root__name-inner']}>{data.name}</span>
          </h3>
        </Link>

        <ControlCart
          isTablet={isTablet}
          classNameAddButton={styles.root__cart}
          classNameControl={styles.root__control}
          product={data}
        />

        <Link to={`/product/${data.slug}`}>
          <InStock data={data} />
        </Link>
      </div>
    </div>
  )
}
